import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ClickOutside from "../ClickOutside";
import UserOne from "../../images/user/user-01.png";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { logoutUser } from "../../app/authSlice";
import { AppDispatch } from "../../app/store";
import Swal from "sweetalert2";

const DropdownUser = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false); // ✅ For loading state
  const navigate = useNavigate();
  const [user, setUser] = useState(() =>
    JSON.parse(localStorage.getItem("user") || "{}")
  );
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const handleStorageChange = () => {
      const updatedUser = JSON.parse(localStorage.getItem("user") || "{}");
      setUser(updatedUser);
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);
  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out from this session!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#000000",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Logout",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setConfirmLoading(true);
        try {
          const res = await dispatch(logoutUser()).unwrap();
          toast.success(res.message || "Logged out successfully");
          localStorage.clear();
          navigate("/");
        } catch (err: any) {
          navigate("/");
          //toast.error(err || "Logout failed");
        } finally {
          setConfirmLoading(false);
        }
      }
    });
  };

  return (
    <ClickOutside onClick={() => setDropdownOpen(false)} className="relative">
      <Link
        onClick={(e) => {
          e.preventDefault();
          setDropdownOpen(!dropdownOpen);
        }}
        className="flex items-center gap-4"
        to="#"
      >
        <span className="hidden text-right lg:block">
          <span className="block text-sm font-medium text-black dark:text-white">
            {(user?.first_name && user?.last_name
              ? `${user.first_name} ${user.last_name}`
              : user?.name || "Thomas Anree"
            ).trim()}
          </span>

          <span className="block text-xs">
            {user.email || "thomas@gmail.com"}
          </span>
        </span>
        <span className="h-12 w-12 rounded-full overflow-hidden">
          <span className="h-12 w-12 rounded-full overflow-hidden flex items-center justify-center bg-gray-300 text-white font-semibold">
            {user?.profile_image ? (
              <img
                src={user.profile_image}
                alt="User"
                className="object-cover w-full h-full rounded-full"
                onError={(e) => {
                  (e.target as HTMLImageElement).style.display = "none"; // hide broken image
                  (e.target as HTMLImageElement).parentElement!.textContent =
                    user?.name?.charAt(0).toUpperCase() || "U"; // fallback to initial
                }}
              />
            ) : (
              <span>{user?.name?.charAt(0).toUpperCase() || "U"}</span>
            )}
          </span>
        </span>

        {/* Chevron */}
        <svg
          className="hidden fill-current sm:block"
          width="12"
          height="8"
          viewBox="0 0 12 8"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.41 0.91a1 1 0 011.18 0L6 5.32l4.41-4.41a1 1 0 111.18 1.18l-5 5a1 1 0 01-1.18 0l-5-5a1 1 0 010-1.18z"
          />
        </svg>
      </Link>

      {/* Dropdown Menu */}
      {dropdownOpen && (
        <div className="absolute right-0 mt-4 flex w-62.5 flex-col rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
          <ul className="flex flex-col border-b border-stroke gap-3.5 px-6 py-4 dark:border-strokedark">
            <li>
              <Link
                to="/dashboard/profile"
                className="flex items-center gap-3.5 text-sm font-medium duration-300 ease-in-out hover:text-primary lg:text-base"
              >
                <svg
                  className="fill-current"
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                >
                  <path d="M11 9.625c-2.578 0-4.641-2.028-4.641-4.504C6.359 2.646 8.422.619 11 .619c2.578 0 4.641 2.028 4.641 4.503 0 2.476-2.063 4.503-4.641 4.503z" />
                  <path d="M17.772 21.416H4.228c-.688 0-1.238-.55-1.238-1.238V17.084c0-3.369 2.75-6.119 6.119-6.119h3.816c3.369 0 6.119 2.75 6.119 6.119v3.094c-.034.653-.584 1.238-1.272 1.238z" />
                </svg>
                My Profile
              </Link>
            </li>
          </ul>
          <button
            onClick={handleLogout}
            className="flex items-center gap-3.5 px-6 py-4 text-sm font-medium duration-300 ease-in-out hover:text-primary lg:text-base"
          >
            <svg
              className="fill-current"
              width="22"
              height="22"
              viewBox="0 0 22 22"
            >
              <path d="M15.538.619H11.653a1.25 1.25 0 00-1.65 1.65v2.372c0 .412.344.756.756.756s.791-.344.791-.756V2.234c0-.069.034-.103.103-.103h3.884c.825 0 1.478.653 1.478 1.478v14.747c0 .825-.653 1.478-1.478 1.478h-3.884c-.069 0-.103-.034-.103-.103v-2.372a.78.78 0 00-.791-.791.78.78 0 00-.756.791v2.372c0 .893.756 1.65 1.65 1.65h3.884c1.684 0 3.025-1.375 3.025-3.025V3.644C18.563 1.96 17.188.619 15.538.619z" />
              <path d="M6.05 11.756h6.153a.76.76 0 000-1.513H6.084l2.132-2.166a.764.764 0 00-1.1-1.1L3.678 10.484a.764.764 0 000 1.1l3.438 3.507a.76.76 0 001.1-1.1L6.05 11.756z" />
            </svg>
            Log Out
          </button>
        </div>
      )}
    </ClickOutside>
  );
};

export default DropdownUser;
